import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnInit,
} from '@angular/core';
import {
  AbstractControl,
  ControlContainer,
  UntypedFormGroup,
} from '@angular/forms';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-form-base-form-group',
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class BaseFormGroupComponent<T extends object> implements OnInit {
  form!: UntypedFormGroup;
  protected readonly controlContainer = inject(ControlContainer);

  ngOnInit(): void {
    this.loadForm();
  }

  get disabled(): boolean {
    return this.form.disabled;
  }

  get enabled(): boolean {
    return this.form.enabled;
  }

  get invalid(): boolean {
    return this.form.invalid;
  }

  get valid(): boolean {
    return this.form.valid;
  }

  get statusChanges(): Observable<string> {
    return this.form.statusChanges;
  }

  get valueChanges(): Observable<T> {
    return this.form.valueChanges;
  }

  get value(): T {
    return this.form.value;
  }

  protected getRawValue(): T {
    return this.form.getRawValue();
  }

  protected setValue(value: T): void {
    this.form.setValue(value);
  }

  protected patchValue(value: Partial<T>): void {
    this.form.patchValue(value);
  }

  private loadForm(): void {
    const form: AbstractControl | null = this.controlContainer.control;

    if (!(form instanceof UntypedFormGroup)) {
      console.error('BaseFormGroupComponent expects an instance of FormGroup');
      return;
    }

    this.form = form;
  }
}
